"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ignoreActions = new Set([
    'INITIALIZE_NMRIUM',
    'SECRET_THROW_ERROR',
    'APPLY_KEY_PREFERENCES',
    'BRUSH_END',
    'RESET_SELECTED_TOOL',
    'SET_KEY_PREFERENCES',
    'SET_LOADING_FLAG',
    'SET_SELECTED_TOOL',
    'SET_SPECTRUMS_VERTICAL_ALIGN',
    'SET_VERTICAL_INDICATOR_X_POSITION',
    'SET_DIMENSIONS',
    'SET_X_DOMAIN',
    'SET_Y_DOMAIN',
    'SET_ZOOM',
    'CALCULATE_MANUAL_PHASE_CORRECTION_FILTER',
    'CHANGE_SPECTRUM_DISPLAY_VIEW_MODE',
    'FULL_ZOOM_OUT',
    'SET_ACTIVE_TAB',
    'CHANGE_SPECTRUM_VISIBILITY',
    'CHANGE_SPECTRA_VISIBILITY_BY_NUCLEUS',
    'CHANGE_ACTIVE_SPECTRUM',
    'CHANGE_FLOAT_MOLECULE_POSITION',
    'ALIGN_SPECTRA',
    'TOGGLE_REAL_IMAGINARY_VISIBILITY',
    'FLOAT_MOLECULE_OVER_SPECTRUM',
    'TOGGLE_SPECTRA_LEGEND',
    'TOGGLE_MOLECULE_ATOM_NUMBER',
]);
function checkActionType(type) {
    if (!ignoreActions?.has(type))
        return true;
    return false;
}
exports.default = checkActionType;
